import React, { useEffect } from 'react';
import ModalDialog from '../../components/ModalDialog'
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import 'font-awesome/css/font-awesome.css';
import 'holderjs'
import 'moment-timezone';

import SideNavBar from '../../components/SideNav'
import  NavBar from '../../components/NavBar'
import { Container } from 'react-bootstrap'
import { navigate, Redirect, useLocation } from '@reach/router';

function App( props ) {
  const origin = props['*'].split('/')[0]
  const { pathname } = useLocation();

  useEffect(() => {
    pathname === '/' && navigate('/inicio');
  }, [pathname]);

  return (
    <>
      {/** Redirecto to initial component if the path does not match */
        // props.path === '/' &&
        //   <Redirect to={`/inicio`} noThrow/>
      }
      <div className='App'>
        <SideNavBar />
        <div className='App-container'>
          <NavBar />
          {props.children}
        </div>
        <ModalDialog />
      </div>
    </>
  );
}

export default App;
